import {get} from './base.service'
export default{
    // 查询检验报告详情
    getLabDetail(params){
        return get('/app/report/lab/detail/{cardType}/{cardNo}/{startDate}/{endDate}/{labId}', {params: params}).then(res => {
            if (res.resultCode === '1') {
                var arr = res.data.items
                var map = {}
                var dest = []
                for (var i = 0; i < arr.length; i++) {
                    var item = arr[i];
                    if (!map[item.labItem]) {
                        dest.push({
                            labItem: item.labItem,
                            itemName: item.itemName,
                            itemResult: item.itemResult,
                            refRange: item.refRange,
                            refRangeMin: item.refRangeMin,
                            refRangeMax: item.refRangeMax,
                            itemUnit: item.itemUnit,
                            itemNote: item.itemNote,
                            data: [item]
                        });
                        map[item.labItem] = item;
                    } else {
                        for (var j = 0; j < dest.length; j++) {
                            var itemSame = dest[j];
                            if (itemSame.labItem === item.labItem) {
                                itemSame.data.push(item);
                                break;
                            }
                        }
                    }
                }
                res.data.items = dest;
                return res;
            } else {
                return res;
            }
        })
    },
    // 查询检查报告详情
    getExamDetail(params){
        return get('/app/report/exam/detail/{cardType}/{cardNo}/{startDate}/{endDate}/{examId}', {params: params});
    }
}



// WEBPACK FOOTER //
// ./src/service/queryFunDetail.service.js